module.exports = (__webpack_require__(0))(59);


//////////////////
// WEBPACK FOOTER
// delegated ./src/utilities/EventStream.js from dll-reference girder_lib
// module id = 10
// module chunks = 0